// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriberLicenseUpsearchModel } from './prescriberLicenseUpsearchModel.js';
import type { TrialcardPrescriberV3ModelsSharedAddressUpsearchModel } from './trialcardPrescriberV3ModelsSharedAddressUpsearchModel.js';
import type { TrialcardPrescriberV3ModelsSharedEmailAddressUpsearchModel } from './trialcardPrescriberV3ModelsSharedEmailAddressUpsearchModel.js';
import type { TrialcardPrescriberV3ModelsSharedPhoneUpsearchModel } from './trialcardPrescriberV3ModelsSharedPhoneUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PrescriberRequestModel {
    /**
    * @description List of Prescriber Licenses
    */
    'prescriberLicenses'?: Array<PrescriberLicenseUpsearchModel> | null;
    /**
    * @description List of Addresses
    */
    'addresses'?: Array<TrialcardPrescriberV3ModelsSharedAddressUpsearchModel> | null;
    /**
    * @description List of Phone Numbers
    */
    'phoneNumbers'?: Array<TrialcardPrescriberV3ModelsSharedPhoneUpsearchModel> | null;
    /**
    * @description List of Email Addresses
    */
    'emailAddresses'?: Array<TrialcardPrescriberV3ModelsSharedEmailAddressUpsearchModel> | null;
    /**
    * @description First Name
    */
    'firstName'?: string | null;
    /**
    * @description Middle Name
    */
    'middleName'?: string | null;
    /**
    * @description Last Name
    */
    'lastName'?: string | null;
    /**
    * @description Name Suffix
    */
    'suffix'?: string | null;
    /**
    * @description Nickname
    */
    'nickname'?: string | null;
    /**
    * @description Npi
    */
    'npi'?: string | null;
    /**
    * @description TaxId
    */
    'taxId'?: string | null;
    /**
    * @description Party Role Additional Note
    */
    'note'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PrescriberRequestModel>> = [
        {
            "name":     "prescriberLicenses",
            "baseName": "prescriberLicenses",
            "type":     "Array<PrescriberLicenseUpsearchModel>"
        },
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<TrialcardPrescriberV3ModelsSharedAddressUpsearchModel>"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<TrialcardPrescriberV3ModelsSharedPhoneUpsearchModel>"
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     "Array<TrialcardPrescriberV3ModelsSharedEmailAddressUpsearchModel>"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "nickname",
            "baseName": "nickname",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "note",
            "baseName": "note",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PrescriberRequestModel.attributeTypeMap;
    }
}
